(function() {
  if (App.angularApp == null) {
    return;
  }


  /*
  mf-popover-validate displays of backend validation on the frontend.
  This allows us to define uniform validation in just one location.
  
  To use:
  1) apply directive to input
  2) input must be in a <form>
  3) input must have an id
  4) front end must extend Angular/Controller (adds validationErrors and validate stub)
  5) `pretend` must be passed when saving
  6) save function must handle 422 error and set validationErrors
  
  Example of save function
  
  >   save: (pretend = false) =>
  >        @scope.$emit 'save' if not pretend
  >        @service.save(pretend, save_data)
  >       .then (response) =>
  >            @scope.validationErrors = null
  >            @closeWithAlert(response.data.status) if not pretend
  >        .catch (response) =>
  >            if response.status is 422
  >                @scope.validationErrors = response.data
  >            @q.reject()
  
  NOTE: directive doesn't detect change if the input is using ui-mask.
  You must manually specify ng-change='save(pretend)'
   */

  App.angularApp.directive('mfPopoverValidate', [
    '$rootScope', '$compile', function($rootScope, $compile) {
      return {
        restrict: 'A',
        replace: false,
        terminal: true,
        priority: 1000,
        link: (function(_this) {
          return function(scope, element, attrs, ctrl) {
            var form, formName, formScope, name, placement, template, tooltip_name;
            name = attrs.mfPopoverValidate || attrs.ngModel;
            placement = attrs.errorPlacement || 'right';
            if (name == null) {
              throw new Error('Element with mf-popover-validate must specify ng-model or define the key on scope.validationErrors to watch!');
            }
            if (element.attr('id') == null) {
              throw new Error('Element with mf-popover-validate must specify an id');
            }
            if (element.attr('id') && !element.attr('name')) {
              element.attr('name', element.attr('id'));
            }
            element.parent().addClass('error-tooltip-container');
            form = element.closest('form');
            if (form == null) {
              throw new Error('You must use mf-popover-validate inside a <form> with a name');
            }
            formScope = form.scope();
            formName = form.attr('name');
            if (formName == null) {
              throw new Error('You must use mf-popover-validate inside a <form> with a name');
            }
            tooltip_name = name.replace(/[\.]+/g, '_');
            if (element.parent().find("#mfPopoverErrorTemplate" + tooltip_name + ".html").length === 0) {
              template = angular.element("<script type='text/ng-template' id='mfPopoverErrorTemplate" + tooltip_name + ".html'> <span class='mf-popover-validate-css'> <% validationErrors['" + name + "'].join(' ') %> </span> </script>");
              element.after(template);
              $compile(template)(scope);
            }
            scope["mfPopoverErrorTemplate" + tooltip_name] = "mfPopoverErrorTemplate" + tooltip_name + ".html";
            element.attr('uib-tooltip-template', "<% 'mfPopoverErrorTemplate" + tooltip_name + "' %>");
            element.attr('tooltip-trigger', 'mouseenter');
            element.attr('tooltip-placement', placement);
            element.attr('tooltip-enable', "validationErrors['" + name + "'] !== undefined");
            scope.$watch("validationErrors['" + name + "']", function(newValue, oldValue) {
              var ref;
              if (formScope[formName][name].$pristine) {
                if ((ref = scope.validationErrors) != null) {
                  delete ref[name];
                }
                return;
              }
              if (newValue !== oldValue && newValue) {
                return element.addClass('mfvalidate-invalid');
              } else {
                return element.removeClass('mfvalidate-invalid');
              }
            });
            element.on('change', function() {
              return scope.$emit('mf-validate');
            });
            $rootScope.$on('save', function() {
              return formScope[formName][name].$setDirty();
            });
            element.removeAttr('mf-popover-validate');
            element.removeAttr('data-mf-popover-validate');
            return $compile(element)(scope);
          };
        })(this)
      };
    }
  ]);

}).call(this);
